'use client';

import { useParams } from 'next/navigation';

import { PlayerStatsDashboard } from '@/app/team-leagues/[teamLeagueId]/(player-details)/player-details/_components/player-stats-dashboard';
import { CurrentAndUpcomingMatchupsContainer } from '@/components/molecules/CurrentAndUpcomingMatchupsContainer';
import { MatchupCardContainerSkeleton } from '@/components/pages/skeletons/MatchupCardsSkeleton';
import { usePlayerProfileStatsQuery } from '@/hooks/player-details/player-profile-stats';

export const PlayerDetailsStatsPage = () => {
	return (
		<div className="w-full flex flex-col gap-10">
			<CurrentAndUpcomingMatchupsContainerWrapper />
			<PlayerStatsDashboard />
		</div>
	);
};

const CurrentAndUpcomingMatchupsContainerWrapper = () => {
	const params = useParams<{
		teamLeagueId: string;
		playerId: string;
	}>();
	const { data: playerProfileStats, isLoading: isLoadingPlayerProfileStats } = usePlayerProfileStatsQuery(params.teamLeagueId, params.playerId);

	if (isLoadingPlayerProfileStats) {
		return <MatchupCardContainerSkeleton />;
	}

	if (playerProfileStats?.statusCode !== 200) {
		throw new Error(playerProfileStats?.error);
	}

	return (
		<CurrentAndUpcomingMatchupsContainer
			currentMatchups={playerProfileStats?.data?.currentMatchups || []}
			upcomingMatchups={playerProfileStats?.data?.upcomingMatchups || []}
		/>
	);
};
